import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const screenshots = [
  { src: '/images/rv1.png', title: 'Find the Perfect Party' },
  { src: '/images/rv2.png', title: 'Embrace the Adventure' },
  { src: '/images/rv3.png', title: 'Music Lovers Rejoice' },
  { src: '/images/rv4.png', title: 'Exclusive VIP Access' },
];

const ScreenshotsSection = () => {
  return (
    <section id="screenshots" className="relative py-24 lg:py-32 bg-[#0a0a0b] overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-radial from-[#ff84e4]/10 via-transparent to-transparent rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-6xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block font-mono text-xs uppercase tracking-widest text-[#d987ff] mb-4">
            User Reviews
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            What People Are
            <span className="text-[#ff84e4]"> Saying</span>
          </h2>
          <p className="text-lg text-white/60 max-w-2xl mx-auto">
            See what our users love about discovering nightlife with XtraGlass
          </p>
        </motion.div>

        {/* Reviews Carousel - Large Readable Layout */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={1}
            spaceBetween={40}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            navigation={true}
            pagination={{ clickable: true }}
            loop={true}
            className="screenshots-swiper py-8"
          >
            {screenshots.map((screenshot, index) => (
              <SwiperSlide key={index}>
                <motion.div
                  className="relative group flex flex-col items-center px-4 md:px-12"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  {/* Title Above */}
                  <h3 className="text-center font-display text-2xl md:text-3xl font-bold text-[#ff84e4] mb-8">
                    {screenshot.title}
                  </h3>
                  
                  {/* Large Screenshot Card */}
                  <div className="relative rounded-2xl overflow-hidden bg-gradient-to-b from-[#ff84e4]/10 via-[#d987ff]/5 to-transparent p-1 shadow-2xl max-w-4xl w-full">
                    <div className="bg-white rounded-xl overflow-hidden">
                      <img
                        src={screenshot.src}
                        alt={screenshot.title}
                        className="w-full h-auto"
                      />
                    </div>
                  </div>
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </div>
    </section>
  );
};

export default ScreenshotsSection;